import React, { useContext, useMemo } from 'react';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import SalesBreakdownCardCo from './SalesBreakdownCardCo';

const SalesBreakdownCardContext = (props: any) => {
  const { config, downloadTitle } = props;
  const { apiDataKey, event, tabKey = 'by_type' } = config || {};
  const { [apiDataKey]: apiData, [tabKey]: byType } = props?.data || {};
  const { filterVal } = useContext(FilterContext);
  const { data, eventData } = useMemo(() => {
    let isLoading = true;
    let isError = false;
    let componentData: any = [];
    let eventData: any = [];
    if (event && Object.keys(event).length !== 0 && event.show === true) {
      const apiEvent = props?.data?.[event.dataKey];
      componentData = apiData?.data;
      isLoading = apiData?.loading || apiEvent?.loading;
      isError = apiData?.errorMsg || apiEvent?.errorMsg;
      eventData = apiEvent?.data;
    } else {
      if (apiData) {
        componentData = apiData?.data;
        isLoading = apiData?.loading;
        isError = apiData?.errorMsg;
      }
    }

    return {
      data: {
        componentData,
        isLoading,
        isError
      },
      eventData
    };
  }, [apiData, event, props?.data]);


  return (
    <>
      <SalesBreakdownCardCo
        data={data}
        config={config}
        formValue={filterVal}
        eventData={eventData}
        byType={byType}
        bordered={false}
        downloadTitle={downloadTitle}
      />
    </>
  );
};

export default SalesBreakdownCardContext;